import { useGetClaimCreditLinkQuery } from '@/redux/api/client/creditTracker';
import PageLoading from '@/routes/PageLoading';
import { Navigate, useParams } from 'react-router-dom';

const ClaimCreditLinkResolver = () => {
  const itemPk = useParams()['itemPk'];
  const { data: claimCreditLink, isLoading } = useGetClaimCreditLinkQuery(itemPk!);
  const url = claimCreditLink ? new URL(claimCreditLink) : undefined;
  if (isLoading) return <PageLoading />;
  if (url) {
    window.location.href = url.href;
    return null;
  }

  return <Navigate to={'/'} replace />;
};

export default ClaimCreditLinkResolver;
